import { useReveal } from "../lib/useReveal";
import { CircleX, CircleCheck } from "lucide-react";

const OLD = [
    "Generic mental health apps that don't understand addiction",
    "2 AM cravings with no one to call — and no group chat you trust",
    "Journals in notebooks that get lost (or read by someone)",
    "Endless Google searches for treatment — no idea who's legit",
    "Streaks that shame you the moment you slip",
];

const NEW = [
    "Hope — AI companion trained for CBT, mindfulness & motivational support",
    "24/7 judgment-free support — even at 2 AM when it matters most",
    "End-to-end encrypted journaling — only you can read it, ever",
    "Verified treatment directory — sober living, rehabs, outpatient, resources",
    "Progress tracking that celebrates effort, never punishes setbacks",
];

// Problem/Solution comparison — styled exactly like soberfriend.io's old-way vs new-way section
export default function ProblemSolution() {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="problem-solution-section"
            className="py-20 md:py-24 bg-muted/30 border-y"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-14 reveal">
                    <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
                        Recovery apps feel like HR software. Yours shouldn&apos;t.
                    </h2>
                    <p className="text-lg text-muted-foreground">
                        Most recovery tools were built by people who&apos;ve never been through it.
                        Hope was designed with people actually in recovery, around the moments that
                        really matter.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-6 reveal">
                    {/* Old way */}
                    <div className="bg-card border rounded-2xl p-8">
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-semibold mb-4 uppercase tracking-wide">
                            <CircleX className="w-3.5 h-3.5" />
                            The old way
                        </div>
                        <ul className="space-y-3">
                            {OLD.map((item) => (
                                <li
                                    key={item}
                                    className="flex items-start gap-3 text-muted-foreground"
                                >
                                    <CircleX className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* With Genesis */}
                    <div className="bg-card border-2 border-primary/30 rounded-2xl p-8 shadow-lg">
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold mb-4 uppercase tracking-wide">
                            <CircleCheck className="w-3.5 h-3.5" />
                            With Genesis Recovery
                        </div>
                        <ul className="space-y-3">
                            {NEW.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-foreground">
                                    <CircleCheck className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
                                    <span className="font-medium">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
